import Arrow from "../../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import BackIcon from "../../_shared/components/BackIcon";
import AppText from "../../_shared/components/AppText";
import { useState, useEffect } from "react";
import useRestList from "../../_shared/hooks/useRestList";
import { defaultPdfs } from "../defaultPdfs";

import SchedeTecniche from "../../../assets/images/SchedeTecniche.png";
import PriceList from "../../../assets/images/mountingScheme.png";

import DownloadIcon from "../../../assets/images/icons/download_icon.png";
import OpenIcon from "../../../assets/images/icons/open_icon.png";
import { Select } from "antd";
import { Option } from "antd/es/mentions";
import SideMenu from "../../_shared/components/SideMenu";

function MountingSchemes(props) {
  const { setSelectedMenu, MSData, download, MSDataFilter } = props;

  console.log("MS data : ", MSData);

  const [filter, setFilter] = useState();
  const [filterSon, setFilterSon] = useState();

  const [MSDataRender, setMSDataRender] = useState(MSData);
  const [sonFilters, setSonFilters] = useState();

  function filterData() {
    filterSon
      ? setMSDataRender([
          ...MSData.filter(
            (x) => x?.data?.id === String(filterSon) && x?.data?.url
          ),
        ])
      : setMSDataRender([
          ...MSData.filter(
            (x) => x?.data?.id === String(filter) && x?.data?.url
          ),
          ...MSData.filter(
            (x) => x?.data?.parentMS?.id === String(filter) && x?.data?.url
          ),
        ]);

    !filterSon &&
      setSonFilters(
        MSData.filter((x) => x?.data?.parentMS?.id === String(filter))
      );
  }

  useEffect(() => {
    filter && filterData();
  }, [filter, filterSon]);

  function setFilterAndResetSonfilter(key) {
    setFilterSon();
    setFilter(key);
  }

  function renderMS() {
    return (
      <div className="row">
        {MSDataRender?.map((x) => (
          <div
            style={styles.pdfCard}
            onClick={() => download(x?.data?.url, x?.data?.name?.it)}
          >
            {console.log("?.data?.pdfDetail :", x?.data)}
            <img
              alt=""
              src={x?.data?.image}
              style={{ height: 240, width: 240, objectFit: "cover" }}
            ></img>
            <div>
              {x?.data?.parentMS ? (
                <div>
                  <div style={styles.inline}>
                    <AppText small bold>
                      {x?.data?.parentMS?.name?.it}&nbsp;/&nbsp;
                      {x?.data?.parentMS?.name?.en}
                    </AppText>
                  </div>
                  <div style={styles.inline}>
                    <AppText small light>
                      {x?.data?.name?.it}&nbsp;
                      {x?.data?.name?.en && `/ ${x?.data?.name?.en}`}
                    </AppText>
                  </div>
                </div>
              ) : (
                <div style={styles.inline}>
                  <AppText small bold>
                    {x?.data?.name?.it}&nbsp;
                    {x?.data?.name?.en && `/ ${x?.data?.name?.en}`}
                  </AppText>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  console.log("sonFilters : ", sonFilters);
  function renderFilters() {
    return (
      <div className="row" style={{ marginTop: 30 }}>
        <Select
          style={{ width: 400, marginRight: 30 }}
          showSearch
          placeholder="Tipologia / Type"
          onChange={(value, key) => setFilterAndResetSonfilter(key?.key)}
          filterOption={(input, option) =>
            (option.value ?? "").toLowerCase().includes(input.toLowerCase())
          }
        >
          {MSDataFilter?.map((x) => (
            <Option
              value={x?.data?.name?.it + " - " + x?.data?.name?.en}
              key={x?.data?.id}
            ></Option>
          ))}
        </Select>
        {sonFilters?.length > 0 && (
          <Select
            style={{ width: 400 }}
            showSearch
            placeholder="Tipologia / Type"
            onChange={(value, key) => setFilterSon(key.key)}
            filterOption={(input, option) =>
              (option.value ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {sonFilters?.map((x) => (
              <Option value={x?.value} key={x?.key}></Option>
            ))}
          </Select>
        )}
      </div>
    );
  }

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        <div>
          <div className="row">
            <BackIcon onClick={() => setSelectedMenu(0)}></BackIcon>
            <div>
              <AppText bold>Schemi di montaggio</AppText>
              <AppText>Assembly instructions</AppText>
            </div>
          </div>
          <div className="row" style={{ marginBottom: 30, marginLeft: 30 }}>
            {renderFilters()}
          </div>
          <div className="row" style={{ marginLeft: 30 }}>
            {renderMS()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MountingSchemes;

const styles = {
  inline: {
    display: "flex",
    flexDirection: "row",
  },
  pdfCard: {
    width: 240,
    marginRight: 50,
    marginBottom: 50,
    maxHeight: 350,
    cursor: "pointer",
    // border: "0.1px solid black",
  },
};
